import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from "@angular/router";
import { loadingFade } from '../../animacoes';
import { NgOption } from '@ng-select/ng-select';

import { AuthService } from '../services/auth.service';
import { ProdutoService } from '../services/produto.service';
import { FornecedorService } from '../services/fornecedor.service';
import { GrupoProdutoService } from '../services/grupo-produto.service';
import { UnidadeMedidaService } from '../services/unidade-medida.service';
import * as moment from 'moment';
import Swal from 'sweetalert2';
import * as Datepicker from 'js-datepicker';

@Component({
  selector: 'app-estoque-edit',
  templateUrl: './estoque-edit.component.html',
  styleUrls: ['./estoque-edit.component.css'],
	animations: [loadingFade]
})
export class EstoqueEditComponent implements OnInit {
  public loading;

	public submitting = false;
	public produto_id = null;
	public fornecedores;
	public gruposProduto;
	public unidadesMedida;
  public dataValidadeLote = false; 
  public data_validade;

  public grupo_produto_lote;

  //filtro
  public produto_codigo___produto_codigo = null;
  public produto_descricao___produto_descricao = null;
  public fornecedor_id___fornecedor_id = null;
  public grupo_produto_id___grupo_produto_id = null;
  public produto_valor___valorMin = null;
  public produto_valor___valorMax = null;
  public produto_qtd___produto_qtd = null;

  public href: string = "";
	public hiddenSubmit = false;
  public isLote = false;

	public formProduto: FormGroup;

  constructor(private authSvc: AuthService,
              private route: ActivatedRoute,
              private fb: FormBuilder,
              private produtoSvc: ProdutoService,
              private fornecedorSvc: FornecedorService,
              private grupoProdutoSvc: GrupoProdutoService,
              private unidadeMedidaSvc: UnidadeMedidaService,
              private router: Router) { }

  ngOnInit() {

    this.href = this.router.url;
    let path = this.router.url;	
    let pathS = path.split("/"); 

    if(pathS[3] == "ver"){
      this.criaFormDisabled();
      this.hiddenSubmit = true;
    }else{
      this.criaForm();
    }

    this.pegaFornecedores();
    this.pegaGruposProduto();
    this.pegaUnidadesMedida();
    //this.criaForm();
    this.loading = true;
    this.route.params.subscribe( params => {
			if (params.id) {


        var splitFiltro = params.id.split("?");

				if(splitFiltro[1] !== undefined){
				  
				  var splitfiltro = splitFiltro[1].split("&");
				  for (let f in splitfiltro) {
		
					var loSplitValor = splitfiltro[f].split("=");
		
					switch(loSplitValor[0]) { 
					  case "produto_codigo___produto_codigo": { 
						 this.produto_codigo___produto_codigo = loSplitValor[1];
						 break; 
					  } 
					  case "produto_descricao___produto_descricao": { 
						this.produto_descricao___produto_descricao = loSplitValor[1];
						 break; 
					  } 
					  case "fornecedor_id___fornecedor_id": { 
              this.fornecedor_id___fornecedor_id = parseInt(loSplitValor[1]);
               break; 
              }             
					  case "grupo_produto_id___grupo_produto_id": { 
						this.grupo_produto_id___grupo_produto_id = parseInt(loSplitValor[1]);
						 break; 
					  }      
					  case "produto_valor___valorMin": { 
						this.produto_valor___valorMin = loSplitValor[1];
						 break; 
					  }      
					  case "produto_valor___valorMax": { 
              this.produto_valor___valorMax = loSplitValor[1];
               break; 
              }             
              case "produto_qtd___produto_qtd": { 
                this.produto_qtd___produto_qtd = loSplitValor[1];
                 break; 
                }             
                                                       
				   }
		
				  }
		
		
				}	

				this.produto_id = params.id;
				// pega dados a partir do id
				this.produtoSvc.getProduto(params.id).then((data: any) => {
					this.preencheForm({
						usuario_id:this.authSvc.getUsuarioId(),
            unidade_id: '',
            cliente_id: '',
            produto_codigo: data.produto_codigo,
            produto_descricao: data.produto_descricao,
            fornecedor_id: data.fornecedor_id,
            grupo_produto_id: data.grupo_produto_id,
            produto_localizacao: data.produto_localizacao,
            produto_qtd_min: data.produto_qtd_min,
            produto_qtd: data.produto_qtd,
            unidade_medida_id: data.unidade_medida_id,
            produto_data_validade:  data.produto_data_validade != null ? moment(data.produto_data_validade).format('DD/MM/YYYY') : '',
            produto_lote: data.produto_lote,
            is_produto_lote: data.is_produto_lote
					});

					if(data.is_produto_lote){
						this.isLote = true;
					}          

          /*if(data.grupo_produto_id == 5)   {  
             this.dataValidadeLote = true;
          }else{
            this.dataValidadeLote = false;
          }*/


					this.loading = false;
				});
			}
			else {
				this.loading = false;
			}
		});
  }

  criaForm() {
		this.formProduto = this.fb.group({
      usuario_id:this.authSvc.getUsuarioId(),
      unidade_id:'',
      cliente_id:'',
      produto_codigo: ['', Validators.required],
      produto_descricao: ['', Validators.required],
      fornecedor_id: [null, Validators.required],
      grupo_produto_id: [null, Validators.required],
      produto_localizacao: ['', Validators.required],
      produto_qtd_min: ['', Validators.required],
      produto_qtd: ['', Validators.required],
      unidade_medida_id: [null, Validators.required],
      produto_data_validade: null,
      produto_lote: '',
      is_produto_lote: null
    }); 

  }

  criaFormDisabled() {
		this.formProduto = this.fb.group({
      usuario_id:this.authSvc.getUsuarioId(),
      unidade_id:'',
      cliente_id:'',
      produto_codigo: {value: null, disabled: true},
      produto_descricao: {value: null, disabled: true},
      fornecedor_id: {value: null, disabled: true},
      grupo_produto_id: {value: null, disabled: true},
      produto_localizacao: {value: null, disabled: true},
      produto_qtd_min: {value: null, disabled: true},
      produto_qtd: {value: null, disabled: true},
      unidade_medida_id: {value: null, disabled: true},
      produto_data_validade: {value: null, disabled: true},
      produto_lote: {value: null, disabled: true},
      is_produto_lote: null
    }); 

  }
  
  preencheForm(dados) {
		this.formProduto.setValue(dados);
  }
  
  pegaFornecedores(){
    this.fornecedorSvc.getFornecedores().then((data: any) => {
      this.fornecedores = data;
    }).catch((err) => {
      console.log(err);
    });
  }

  pegaGruposProduto(){
    this.grupoProdutoSvc.getGruposProduto().then((data: any) => {
      this.gruposProduto = data;
    }).catch((err) => {
      console.log(err);
    });
  }

  pegaUnidadesMedida(){
    this.unidadeMedidaSvc.getUnidadesMedida().then((data: any) => {
      this.unidadesMedida = data;
    }).catch((err) => {
      console.log(err);
    });
  }

	enviaProduto() {
		if (this.formProduto.valid) {
			this.submitting = true;

			let toSend = this.formProduto.value;
      if(this.isLote && (toSend.produto_data_validade == null || toSend.produto_lote.length == 0)){

        this.submitting = false;
        Swal.fire({
          type: 'error',
          title: 'Aviso',
          text: 'Favor, preencher a Data de Validade / Lote!.'
        });
        return "";

      }
      
      if(!this.isLote){
        toSend.produto_lote = "";
        toSend.produto_data_validade = null;
      }


			if (this.produto_id === null) { // criar

        let produto_data_validade = "";
        if(toSend.produto_data_validade != null ){          
          produto_data_validade += toSend.produto_data_validade.substr(4, 4);
          produto_data_validade += toSend.produto_data_validade.substr(2, 2);
          produto_data_validade += toSend.produto_data_validade.substr(0, 2);
          toSend.produto_data_validade = produto_data_validade;
        }

				this.produtoSvc.criaProduto(toSend).then((data) => {
          console.log('resp', data);
          Swal.fire({
            type: 'success',
            title: 'Produto cadastrado com sucesso!',
            onClose: () => {
					    this.router.navigate(['home/estoque']);
            }
          });
				}).catch(err => {
          console.log(err);
          this.submitting = false;
          Swal.fire({
            type: 'error',
            title: 'Ops! Algo de errado aconteceu!',
            text: 'Tente novamente mais tarde.'
          });
				});
			}
			else { // editar

        let produto_data_validade = "";

        if(toSend.produto_data_validade != null ){
          
          produto_data_validade = toSend.produto_data_validade.replace('/','').replace('/','');

          let ano = produto_data_validade.substr(4, 4);
          let mes = produto_data_validade.substr(2, 2);
          let dia = produto_data_validade.substr(0, 2);
          produto_data_validade = ano + mes + dia;

          toSend.produto_data_validade = produto_data_validade;

        }


        toSend.produto_id = this.produto_id;
				this.produtoSvc.editaProduto(toSend).then((data) => {
          console.log('resp', data);
          Swal.fire({
            type: 'success',
            title: 'Produto alterado com sucesso!',
            onClose: () => {
					    this.router.navigate(['home/estoque']);
            }
          });
				}).catch(err => {
          console.log(err);
          this.submitting = false;
          Swal.fire({
            type: 'error',
            title: 'Ops! Algo de errado aconteceu!',
            text: 'Tente novamente mais tarde.'
          });
				});
			}
    }
    else{
      for( let field in this.formProduto.controls){
				let campo = this.formProduto.get(field);
				campo.markAsTouched();
			}
      this.submitting = false;
      Swal.fire({
        type: 'error',
        title: 'Atenção!',
        text: 'Verifique os campos obrigatórios e tente novamente.'

      });
    }
	}

  invalid(nome) {
		let input = this.formProduto.get(nome);
		return input.touched && input.invalid;
	}

	onClickVoltar(){
		let params = 'produto_codigo___produto_codigo=' + this.produto_codigo___produto_codigo;
		params += "&produto_descricao___produto_descricao=" + this.produto_descricao___produto_descricao;
    params += "&fornecedor_id___fornecedor_id=" + this.fornecedor_id___fornecedor_id;
		params += "&grupo_produto_id___grupo_produto_id=" + this.grupo_produto_id___grupo_produto_id;
		params += "&produto_valor___valorMin=" + this.produto_valor___valorMin;
    params += "&produto_valor___valorMax=" + this.produto_valor___valorMax;
    params += "&produto_qtd___produto_qtd=" + this.produto_qtd___produto_qtd;

	
		this.router.navigate(['/home/estoquefiltro/' + params]);
	
	  }	

    onChangeGrupo(e){

      if(e.grupo_produto_nome == "MEDICAMENTOS" && e.grupo_produto_lote){
        this.dataValidadeLote = true;
      }else{
        this.dataValidadeLote = false;
      }

    }

    onClickCheckLote(e){

      if(!this.formProduto.controls.is_produto_lote.value){
        this.isLote = true;
      }else{
        this.isLote = false;
      }

    }

    removeCaracteres(e){

      let string = this.formProduto.controls.produto_lote.value;

      string = string.replace(/[ÀÁÂÃÄÅ]/g,"A");
      string = string.replace(/[àáâãäå]/g,"a");
      string = string.replace(/[ÈÉÊË]/g,"E");
      string = string.replace(/[^a-z0-9]/gi,'');
      this.formProduto.controls['produto_lote'].setValue(string);


    }

}
